import { useEffect } from "react";
import { toast } from "react-toastify";
import { useFetchImpactShopStore } from "../../../store/impact-shop";
import { ImpactShopMessagesType } from "../constants";

const useImpactShopStore = useFetchImpactShopStore();

const impactShopNotificationType = {
  [ImpactShopMessagesType.Error]: "error",
  [ImpactShopMessagesType.Success]: "success",
};

export const useImpactShopMessage = () => {
  const { clearMessage, message } = useImpactShopStore();

  useEffect(() => {
    if (!message.body) return;

    const notificationType = impactShopNotificationType[message.type];

    toast[notificationType](message.body, {
      autoClose: 2000,
      onClose: clearMessage,
    });

    return clearMessage();
  }, [message]);
};
